import { Grid, IconButton, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import AtlasPanel from "../../atlas/blades/AtlasPanel";
import Amplify, { Storage } from "aws-amplify";
import { DataPortalService } from "../../api/DataPortalService";
import MaterialTable from "material-table";
import axios from "axios";
const DatasetFiles: React.FC<any> = ({ theme, project, dataset, files }) => {
  if (dataset === null) return <Fragment />;

  return (
    <MaterialTable
      title="Files"
      columns={[
        { title: "Name", field: "name" },
        { title: "Date", field: "date", type: "date" },
        { title: "Size", field: "size" },
      ]}
      actions={[
        (rowData) => ({
          icon: "download",
          tooltip: "Download",
          hidden: rowData.type === "folder",
          onClick: async (event, rowData) => {
            const url = await DataPortalService.getObjectUrl(
              project.id,
              rowData.obj
            );
            axios
              .request({
                url,
                method: "GET",
                responseType: "blob", //important
              })
              .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", rowData.name);
                document.body.appendChild(link);
                link.click();
                link.remove();
              });
          },
        }),
      ]}
      data={files}
      parentChildData={(row, rows) => {
        const rec = rows.find((a) => a.name === row.parent);
        return rec;
      }}
      options={{
        showTitle: true,
        grouping: false,
        exportButton: false,
        columnsButton: false,
        search: true,
        paging: false,
        actionsColumnIndex: -1,
        headerStyle: {
          fontSize: "12px",
          fontWeight: "bold",
          padding: "3px 10px",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          zIndex: 0,
        },
        rowStyle: {
          fontSize: "13px",
        },
      }}
    />
  );
};

export default DatasetFiles;
